import React from "react";
import AdminLiveUpdates from "../../admin-live-updates/AdminLiveUpdates";

const SectionEntityLiveFeed = (props) => {
  return <AdminLiveUpdates />;
};
export default SectionEntityLiveFeed;
